'use strict'
module.exports = require('./lib/api')(require('bindings')('keccak'))



//////////////////
// WEBPACK FOOTER
// ./~/keccak/bindings.js
// module id = 1467
// module chunks = 0 1 2